// booking.lang.es.js
const bookingES = {
	weekLabel: "{start} – {end}",
	week: {
		previous: "Semana anterior",
		next: "Semana siguiente",
	},
	noSlots: "No hay horarios disponibles",
	staff: {
		title: "Elige tu Profesional",
		any: "Cualquier personal",
	},
	services: {
		title: "Confirma tus Servicios",
		add: "+ Añadir servicio",
		selected: "{name} • {duration} min — ${price}",
		remove: "Quitar servicio",
		notMixable: " (No combinable)",
		lockedHome: "Solo puedes añadir servicios a domicilio en esta reserva.",
		lockedShop: "Solo puedes añadir servicios en el local en esta reserva.",
		cantMix: "No puedes mezclar servicios a domicilio con servicios en el local.",
	},
	serviceType: {
		home: "A domicilio",
		online: "En línea",
	},
	home: {
		title: "Detalles del servicio a domicilio",
		extraDetails: "Detalles adicionales (opcional) — apto, referencia, etc.",
	},
	guest: {
		title: "Tus Datos",
		fullName: "Nombre completo",
		email: "Correo electrónico",
	},
	contact: {
		title: "Número de contacto",
		hint: "No tenemos un número de teléfono en tu cuenta — el negocio lo necesita para comunicarse contigo sobre esta reserva.",
	},
	steps: {
		book: "Tu cita",
		when: "Fecha y hora",
		review: "Revisar",
	},
	stepHints: {
		book: "Elige tus servicios, la hora que te convenga y cómo contactarte.",
		review: "Un último vistazo y la enviamos.",
	},
	review: {
		title: "Revisar y confirmar",
		where: "Dónde",
		when: "Cuándo",
		professional: "Profesional",
		services: "Servicios",
		contact: "Contacto",
		total: "Total",
		atShop: "En el local",
		homeVisit: "En tu dirección",
	},
	buttons: {
		confirm: "Confirmar Reserva",
		confirmReschedule: "Confirmar Reprogramación",
		next: "Siguiente",
		back: "Atrás",
		close: "Cerrar",
	},
	toast: {
		noServiceOrTime: "Selecciona al menos un servicio y un horario",
		missingService: "Por favor selecciona al menos un servicio.",
		missingTime: "Por favor selecciona una hora.",
		missingGuest: "Por favor proporciona tu nombre, correo y número de teléfono",
		missingPhone: "Agrega un número de teléfono para que el negocio pueda contactarte.",
		noStaff: "No hay personal disponible para esa hora",
		pastTime: "Esa hora ya pasó. Elige otro horario para continuar.",
		bookingConfirmed: "¡Todo listo! Tu reserva está confirmada y te enviamos un correo con los detalles.",
		rescheduled: "¡Listo! Tu reserva fue reprogramada con éxito.",
		couldNotReschedule: "No pudimos reprogramar tu reserva. Inténtalo de nuevo.",
		couldNotConfirm: "No pudimos confirmar tu reserva. Inténtalo de nuevo.",
		timeInvalidated: "La hora seleccionada ya no está disponible para los servicios elegidos.",
		missingStaff: "Por favor selecciona al menos un miembro del personal",
		missingAddress: "Por favor ingresa una dirección válida para el servicio a domicilio.",
	},
	timeFilters: {
		morning: "Mañana",
		afternoon: "Tarde",
		evening: "Noche",
	},
	summary: {
		noServices: "Ningún servicio seleccionado",
		oneService: "1 servicio",
		multipleServices: "{n} servicios",
	},
};

export default bookingES;
